import { useState, useMemo } from 'react'
import { useQueryGetOrganizationSubscriptionStatus } from '../queries/paymentQueries'

const AJUSTES_PATH = '/ajustes'
const AJUSTES_PAGOS_PATH = '/ajustes?tab=pagos'

export const useSubscriptionGuard = (organizationId) => {
  const { data: subscriptionStatus, isFetched: isSubscriptionFetched } =
    useQueryGetOrganizationSubscriptionStatus(organizationId)
  const [dismissedSubscriptionWarning, setDismissedSubscriptionWarning] = useState(false)

  const subscriptionModal = useMemo(() => {
    if (!subscriptionStatus || !isSubscriptionFetched) return null
    const { hasActiveSubscription, daysUntilBlock, hasDebt } = subscriptionStatus
    const isBlocked =
      !hasActiveSubscription || daysUntilBlock === 0
    const isWarning = daysUntilBlock != null && daysUntilBlock > 0
    const hasFailedAttempts = hasDebt === true

    if (isBlocked) {
      return {
        show: true,
        closable: false,
        title: 'Acceso bloqueado',
        body:
          'Tu suscripción tiene problemas y el acceso ha sido bloqueado. Por favor regulariza tu situación en Ajustes > Pagos.',
        primaryLabel: 'Ir a Ajustes',
        primaryTo: AJUSTES_PAGOS_PATH,
        secondaryLabel: null
      }
    }
    if (isWarning) {
      const days = subscriptionStatus.daysUntilBlock
      return {
        show: true,
        closable: true,
        title: 'Problemas con tu suscripción',
        body: `Tu suscripción tiene problemas. El acceso se bloqueará en ${days} ${days === 1 ? 'día' : 'días'}. Por favor regulariza tu situación en Ajustes > Pagos.`,
        primaryLabel: 'Ir a Ajustes',
        primaryTo: AJUSTES_PAGOS_PATH,
        secondaryLabel: 'Entendido'
      }
    }
    if (hasFailedAttempts) {
      return {
        show: true,
        closable: true,
        title: 'Intentos de cobro fallidos',
        body:
          'Hay intentos de cobro fallidos. Por favor actualiza tu método de pago en Ajustes > Pagos.',
        primaryLabel: 'Ir a Ajustes',
        primaryTo: AJUSTES_PAGOS_PATH,
        secondaryLabel: 'Entendido'
      }
    }
    return null
  }, [subscriptionStatus, isSubscriptionFetched])

  const isBlocked =
    subscriptionStatus &&
    !subscriptionStatus.hasActiveSubscription &&
    (subscriptionStatus.daysUntilBlock === 0 || subscriptionStatus.daysUntilBlock === null)

  const showBlockModal =
    subscriptionModal?.show &&
    (subscriptionModal.closable ? !dismissedSubscriptionWarning : true)

  const canAccessRoute = (pathname) => {
    if (!isBlocked) return true
    return pathname === AJUSTES_PATH
  }

  const handleCloseModal = () => {
    if (subscriptionModal?.closable) setDismissedSubscriptionWarning(true)
  }

  return {
    subscriptionModal,
    showBlockModal,
    isBlocked,
    canAccessRoute,
    handleCloseModal,
    ajustesPath: AJUSTES_PATH
  }
}
